export * from "./video-template.component";
